import script from "./StorefrontShortcut.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorefrontShortcut.vue?vue&type=script&setup=true&lang=ts"

import "./StorefrontShortcut.vue?vue&type=style&index=0&id=1199888e&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1199888e"]])

export default __exports__